function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#c)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30 1H2C1.44772 1 1 1.44772 1 2V9C1 9.55228 1.44772 10 2 10H30C30.5523 10 31 9.55228 31 9V2C31 1.44772 30.5523 1 30 1ZM2 0C0.895431 0 0 0.895431 0 2V9C0 10.1046 0.895431 11 2 11H30C31.1046 11 32 10.1046 32 9V2C32 0.895431 31.1046 0 30 0H2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 11H3V14H14V11ZM2 10V14C2 14.5523 2.44772 15 3 15H14C14.5523 15 15 14.5523 15 14V10H2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29 11H18V14H29V11ZM17 10V14C17 14.5523 17.4477 15 18 15H29C29.5523 15 30 14.5523 30 14V10H17Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 16H5V20H12V16ZM4 15V21H13V15H4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27 16H20V20H27V16ZM19 15V21H28V15H19Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 22H5V27H12V22ZM4 21V28H13V21H4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27 22H20V27H27V22ZM19 21V28H28V21H19Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 28C2.89543 28 2 28.8954 2 30C2 31.1046 2.89543 32 4 32H13C14.1046 32 15 31.1046 15 30C15 28.8954 14.1046 28 13 28H4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19 28C17.8954 28 17 28.8954 17 30C17 31.1046 17.8954 32 19 32H28C29.1046 32 30 31.1046 30 30C30 28.8954 29.1046 28 28 28H19Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "c"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "white"
})));

var SvgBufferStop = function SvgBufferStop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBufferStop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/buffer-stop.c977f14f.svg";
export { ForwardRef as ReactComponent };